import { render, staticRenderFns } from "./clear-sync-queue-modal.vue?vue&type=template&id=92227e92&scoped=true&"
import script from "./clear-sync-queue-modal.vue?vue&type=script&lang=js&"
export * from "./clear-sync-queue-modal.vue?vue&type=script&lang=js&"
import style0 from "./clear-sync-queue-modal.vue?vue&type=style&index=0&id=92227e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92227e92",
  null
  
)

export default component.exports